import { T, UI } from "../constants/tokens";
import Icon from "./Icon";

// Shared compact empty state: a small line-icon inline with one line of text
// (+ optional sub-line for a real fact). Never a big centered block — an empty
// card stays small. `framed` wraps it in the standard card surface.
export default function EmptyState({ icon, line, sub, framed = false }) {
  const inner = (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
      {icon && <Icon name={icon} size={17} color={UI.text.muted} style={{ marginTop: 2 }}/>}
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14, color: UI.text.muted, lineHeight: 1.5 }}>{line}</div>
        {sub && <div style={{ fontSize: 12.5, color: UI.text.muted, opacity: 0.75, marginTop: 2 }}>{sub}</div>}
      </div>
    </div>
  );
  if (!framed) return inner;
  return (
    <div style={{ background: UI.surface.raised, border: `1px solid ${UI.line.hairline}`, borderRadius: T.radius.xl, boxShadow: UI.shadow.card, padding: "16px 18px" }}>
      {inner}
    </div>
  );
}
